
import { Navigate } from "react-router-dom";
import { Routes } from "../states/States";
import AuthLogin from "../common/Pages/Login/Login";
import Dashboard from "../modules/churn-dashboard/ChurnPages/ChurnDashboard";
import HomePage from "../common/Pages/HomePage/HomePage";
import FleetDashboard from "../modules/iot-dashboard/IotPages/IotTracker";
import FleetTracking from "../modules/iot-dashboard/IotPages/fleetTracking/riderTrack";
import FleetDistanceInsights from "../modules/iot-dashboard/IotPages/fleetDistanceInsights";
import Reports from "../modules/iot-dashboard/IotPages/reports";
import DashboardSelectionPage from "../common/Pages/DashboardSelection/DashboardSelectionPage";
import Geofence from "../modules/iot-dashboard/IotPages/geofence";
import ClientIdVerification from "../modules/kyc-dashboard/KycPages/clientIDVerification";
import HelpTicket from "../modules/kyc-dashboard/KycPages/helpTicket";
import KycTicket from "../modules/kyc-dashboard/KycPages/kycTicket";
import TlDashboard from "../modules/tl-dashboard/TlPages/TLDashboard";






const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const isAuthenticated = localStorage.getItem("token");
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  return children;
};

const CommonRoutes: Array<Routes> = [
  {
    path: "/",
    element: <AuthLogin />,
  },
  {
    path: "/churn-predictor",
    element: (
      <RequireAuth>
        <Dashboard />
      </RequireAuth>
    ),
  },
  {
    path: "/homepage",
    element: (
      <RequireAuth>
        <HomePage />
      </RequireAuth>
    ),
  },
  {
    path: "/iot-dashboard",
    element: (
      <RequireAuth>
        <FleetDashboard />
      </RequireAuth>
    ),
  },
  {
    path: "/fleet-tracking",
    element: (
      <RequireAuth>
        <FleetTracking />
      </RequireAuth>
    ),
  },
  {
    path: "/fleet-distance",
    element: (
      <RequireAuth>
        <FleetDistanceInsights />
      </RequireAuth>
    ),
  },
  {
    path: "/dashboard-selection",
    element: (
      <RequireAuth>
        <DashboardSelectionPage />
      </RequireAuth>
    ),
  },
  {
    path: "/reports",
    element: (<RequireAuth><Reports/>
    </RequireAuth>)
  },
  {
    path: "/geofence",
    element: (<RequireAuth><Geofence/>
    </RequireAuth>)
  },
  {
    path: "/client-ticket",
    element: (<RequireAuth><ClientIdVerification/>
    </RequireAuth>)
  },
  {
    path: "/help-ticket",
    element: (<RequireAuth><HelpTicket/>
    </RequireAuth>)
  },
  {
    path: "/kyc-ticket",
    element: (<RequireAuth><KycTicket/>
    </RequireAuth>)
  },
  {
    path: "/tl-dashboard",
    element: (<RequireAuth><TlDashboard/>
    </RequireAuth>)
  },
  
];
export const Router: Array<Routes> = [
  ...CommonRoutes,
  /**
   *@description
   * Url to Embeded in Iframe
   *
   */
  // {
  //   path: "", // test route
  //   element: <Header />,
  //   children: [
  //     ...CommonRoutes,
  //     {
  //       path: "*", // test route
  //       element: <div>NOT FOUND</div>,
  //     },
  //   ],
  // },
];
